module.exports = __webpack_public_path__ + "img/sms-icon.037d89ae.png";